import React from 'react';
import ModalTemplate from '../Template';

const ModalConfirm = ({
    handleCancel,
    handleSuccess,
    description
}) => {
    return (
        <ModalTemplate 
            title="Подтверждение действия"
            description={description}
            handleCancel={handleCancel}
            handleSuccess={handleSuccess}
            actionBar={["CLOSE", "CONFIRM"]}
        />
    )
}

export default ModalConfirm;